module.exports = __webpack_public_path__ + "img/process_bg.0fa54b0d.png";